import { PlanType } from 'v2/types'

// Which plan a payment pays for, in one place.
//
// A free-trial account has no subscription to charge against: its FIRST payment
// is what buys the Professional plan. Every gateway carries that intent the same
// way — a `upgrade_plan` field on the order/charge request, which the gateway
// round-trips (Cashfree order tags, Razorpay Notes) and hands back on the
// capture webhook, where payment-service calls AMS UpgradeSubscriptionPlan
// AFTER the credit lands (`razorpay_webhook.go` order.paid,
// `cashfreeclient/webhook.go`). It is the only mechanism that works for an
// async rail: the credit — and therefore the plan flip — happens long after the
// browser is done, so nothing in the console can perform the upgrade itself.
//
// Why a shared helper rather than a literal at each call site: the console has
// SIX Razorpay/Cashfree money-moving calls and the gate was spelled at exactly
// one of them (the Cashfree netbanking order), so every Razorpay path silently
// left a trial account on free_trial after a successful first payment. Re-
// spelling an entitlement gate per call site is failure mode 18; this returns a
// SPREADABLE patch so the decision and the payload shape cannot drift apart.
//
// `isTrial` (from useUserPlan) is the whole input. Deliberately NOT gated on a
// host's `onUpgrade` prop being wired: that is a component-plumbing detail, and
// whether this payment buys the plan is a property of the ACCOUNT.
export const buildUpgradePlanPatch = (isTrial: boolean): { upgrade_plan?: PlanType } =>
  isTrial ? { upgrade_plan: PlanType.PROFESSIONAL } : {}
